// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5v-0";
export var startPickingButton = "_5v-1";